import gettext from '@sdk/lang/gettext';
import { PickerOption } from '@sdk/components/forms/types';

import { HeaderActionOption } from './conversationHeaderActions.types';

export const ACTION_TOAST_ID = 'conversation-action';

export const headerMenuOptions: PickerOption[] = [
  {
    key: HeaderActionOption.EDIT,
    value: HeaderActionOption.EDIT,
    label: gettext('Edit'),
  },
  {
    key: HeaderActionOption.MUTE,
    value: HeaderActionOption.MUTE,
    label: gettext('Mute'),
  },
  {
    key: HeaderActionOption.UNMUTE,
    value: HeaderActionOption.UNMUTE,
    label: gettext('Unmute'),
  },
  {
    key: HeaderActionOption.EXPORT,
    value: HeaderActionOption.EXPORT,
    label: gettext('Export'),
  },
  {
    key: HeaderActionOption.ARCHIVE,
    value: HeaderActionOption.ARCHIVE,
    label: gettext('Archive'),
  },
  {
    key: HeaderActionOption.UNARCHIVE,
    value: HeaderActionOption.UNARCHIVE,
    label: gettext('Unarchive'),
  },
  {
    key: HeaderActionOption.LEAVE,
    value: HeaderActionOption.LEAVE,
    label: gettext('Leave'),
  },
  {
    key: HeaderActionOption.DELETE,
    value: HeaderActionOption.DELETE,
    label: gettext('Delete'),
  },
];
